var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TransferAccount" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "channel-box" }, [
        _c(
          "div",
          { staticClass: "channel-tabs" },
          _vm._l(_vm.channelList, function (item) {
            return _c(
              "div",
              {
                key: item.value,
                staticClass: "channel-tab",
                class: { active: item.value === _vm.tabChannel },
                on: {
                  click: function ($event) {
                    return _vm.onSwitchChannel(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "channel-current" }, [
          _c("span", { staticClass: "channel-current-label" }, [
            _vm._v("当前渠道："),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "channel-current-tag" }, [
            _vm._v(_vm._s(_vm.currentChannelLabel)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "channel-change-btn",
              on: { click: _vm.onChangeChannel },
            },
            [_vm._v("更换")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.changeChannelDialogVisible,
            title: "更换默认转账渠道",
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changeChannelDialogVisible = $event
            },
            close: _vm.onChangeChannelClose,
          },
        },
        [
          _c("div", { staticClass: "change-channel-tip" }, [
            _vm._v(
              "\n      温馨提示：转账渠道为资金核心配置，切换渠道前请仔细核对，避免打款异常\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "changeChannelForm",
              staticClass: "change-channel-form",
              attrs: { "label-width": "110px", "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择支付平台：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.changeChannelValue,
                        callback: function ($$v) {
                          _vm.changeChannelValue = $$v
                        },
                        expression: "changeChannelValue",
                      },
                    },
                    _vm._l(_vm.channelList, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onChangeChannelConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onChangeChannelClose } }, [
                    _vm._v("关闭"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "kapayer-base-config" }, [
        _vm.tabChannel === "kapayer"
          ? _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
              _c("div", { staticClass: "kb-title" }, [
                _c("span", { staticClass: "kb-title-text" }, [
                  _vm._v("基础配置"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "kb-edit-btn",
                    on: { click: _vm.onEditKapayerBase },
                  },
                  [_vm._v("编辑")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "kb-row" }, [
                _c("div", { staticClass: "kb-item" }, [
                  _c("span", { staticClass: "kb-label" }, [
                    _vm._v("快安App Key："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "kb-value",
                      class: { unset: !_vm.kapayerBaseConfig.appKey },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.kapayerBaseConfig.appKey || "未配置") +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "kb-item" }, [
                  _c("span", { staticClass: "kb-label" }, [
                    _vm._v("快安App Secret："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "kb-value",
                      class: { unset: !_vm.kapayerBaseConfig.appSecret },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.kapayerBaseConfig.appSecret || "未配置") +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "kb-item" }, [
                  _c("span", { staticClass: "kb-label" }, [
                    _vm._v("快安岗位 ID："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "kb-value",
                      class: { unset: !_vm.kapayerBaseConfig.jobId },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.kapayerBaseConfig.jobId || "未配置") +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "frb",
            staticStyle: { padding: "0px 0px 0 0px", "font-size": "18px" },
          },
          [
            _c("div", [
              _vm._v("\n        共\n        "),
              _c("span", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(
                  _vm._s(
                    _vm.tabChannel === "alipay"
                      ? _vm.alipayTotal
                      : _vm.kapayerTotal
                  )
                ),
              ]),
              _vm._v("\n        个账号\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "add_btn pointer",
                on: { click: _vm.onAddAccount },
              },
              [_vm._v("添加账户")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt10" },
          [
            _vm.tabChannel === "alipay"
              ? _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    key: "alipay-table",
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.alipayTableData, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "remark",
                        label: "备注名称",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "enable",
                        label: "账号状态",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.defaultAccount
                                  ? _c(
                                      "div",
                                      { staticStyle: { color: "#2DC866" } },
                                      [_vm._v("当前使用")]
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { color: "#A6A6A6" } },
                                      [_vm._v("未使用")]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3326351768
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "alipayAppId",
                        label: "支付宝APP ID",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "", label: "操作", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "kapayer-actions" },
                                  [
                                    !scope.row.defaultAccount
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "success",
                                              plain: "",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSetDefault(
                                                  scope.row.alipayAppId
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("设为使用")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          plain: "",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditor(
                                              scope.row.alipayAppId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          plain: "",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDel(
                                              scope.row.alipayAppId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1099917640
                      ),
                    }),
                  ],
                  1
                )
              : _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    key: "kapayer-table",
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.kapayerTableData, border: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "bookName",
                        label: "账本名称",
                        align: "center",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "账号状态",
                        align: "center",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.inUse
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#2DC866" } },
                                    [_vm._v("当前使用")]
                                  )
                                : _c(
                                    "div",
                                    { staticStyle: { color: "#A6A6A6" } },
                                    [_vm._v("未使用")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "accountBookId",
                        label: "账本ID",
                        align: "center",
                        "min-width": "160",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "balance",
                        label: "账本余额",
                        align: "center",
                        "min-width": "100",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        align: "center",
                        "min-width": "160",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "",
                        label: "操作",
                        align: "center",
                        "min-width": "380",
                        width: "380",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "kapayer-actions" },
                                [
                                  !scope.row.inUse
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            plain: "",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onSetDefaultKapayer(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("设为使用")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "warning",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onSyncBalance(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("余额同步")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEditorKapayer(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        plain: "",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelKapayer(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt20 page_box",
                staticStyle: { "text-align": "right" },
              },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.page,
                    "page-sizes": [20, 30, 40],
                    "page-size": _vm.size,
                    layout: "total, prev, pager, next, sizes,jumper",
                    total:
                      _vm.tabChannel === "alipay"
                        ? _vm.alipayTotal
                        : _vm.kapayerTotal,
                    background: "",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.title,
            "close-on-click-modal": false,
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _vm.OperationType === "add"
            ? _c("div", { staticClass: "add-account-tip" }, [
                _vm._v("为「支付宝」添加一个新的转账账号。"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruFrom",
                  attrs: {
                    model: _vm.ruFrom,
                    rules: _vm.rules,
                    "label-width": "140px",
                    "label-position": "right",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注名称：", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.ruFrom.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "remark", $$v)
                          },
                          expression: "ruFrom.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付宝APPID:", prop: "alipayAppId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.OperationType === "Editor" ? true : false,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.ruFrom.alipayAppId,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "alipayAppId", $$v)
                          },
                          expression: "ruFrom.alipayAppId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "支付宝根证书:",
                        prop: "rootCertContent",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "textarea",
                          rows: 4,
                        },
                        model: {
                          value: _vm.ruFrom.rootCertContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "rootCertContent", $$v)
                          },
                          expression: "ruFrom.rootCertContent",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n            请将下载的证书文件【文件名：alipayRootCert.crt】用 “记事本” 打开，全选复制文件内信息并粘贴在此处\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "支付宝公钥证书:",
                        prop: "alipayPublicCertContent",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "textarea",
                          rows: 4,
                        },
                        model: {
                          value: _vm.ruFrom.alipayPublicCertContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "alipayPublicCertContent", $$v)
                          },
                          expression: "ruFrom.alipayPublicCertContent",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n            请将下载的证书文件【文件名：alipayCertPublicKey_RSA2.crt】用 “记事本” 打开，全选复制文件内信息并粘贴在此处\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用公钥证书:", prop: "certContent" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "textarea",
                          rows: 4,
                        },
                        model: {
                          value: _vm.ruFrom.certContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "certContent", $$v)
                          },
                          expression: "ruFrom.certContent",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n            请将下载的证书文件【文件名：appCertPublicKey_***.crt】用 “记事本” 打开，全选复制文件内信息并粘贴在此处\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用私钥:", prop: "privateKey" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "textarea",
                          rows: 4,
                        },
                        model: {
                          value: _vm.ruFrom.privateKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruFrom, "privateKey", $$v)
                          },
                          expression: "ruFrom.privateKey",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          "\n            请将支付宝开放平台密钥工具生成的【文件名：应用私钥RSA2048***.txt】打开，全选复制文件内信息并粘贴在此处\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruFrom")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onClose } }, [
                        _vm._v("关闭"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.kapayerAddDialogVisible,
            title:
              _vm.kapayerAddDialogType === "edit" ? "编辑账号" : "添加账号",
            width: "520px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.kapayerAddDialogVisible = $event
            },
            close: _vm.onKapayerAddClose,
          },
        },
        [
          _c("div", { staticClass: "kapayer-add-tip" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.kapayerAddDialogType === "edit"
                    ? "编辑【快安支付】账本账号信息。"
                    : "为【快安支付】添加一个新的账本账号。"
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "kapayerAddForm",
              attrs: {
                model: _vm.kapayerAddForm,
                rules: _vm.kapayerAddRules,
                "label-width": "100px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "40px" },
                  attrs: { label: "账本名称：", prop: "bookName" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.kapayerAddForm.bookName,
                      callback: function ($$v) {
                        _vm.$set(_vm.kapayerAddForm, "bookName", $$v)
                      },
                      expression: "kapayerAddForm.bookName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "账本ID：", prop: "accountBookId" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.kapayerAddDialogType === "edit",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.kapayerAddForm.accountBookId,
                      callback: function ($$v) {
                        _vm.$set(_vm.kapayerAddForm, "accountBookId", $$v)
                      },
                      expression: "kapayerAddForm.accountBookId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onKapayerAddConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onKapayerAddReset } }, [
                    _vm._v("关闭"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.kapayerBaseEditDialogVisible,
            title: "基础配置",
            width: "800px",
            "close-on-click-modal": false,
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.kapayerBaseEditDialogVisible = $event
            },
            close: _vm.onKapayerBaseEditClose,
          },
        },
        [
          _c("div", { staticClass: "kapayer-base-edit-tip" }, [
            _vm._v("添加转账账号前记得先对接快安App Key和App Secret"),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "kapayerBaseEditForm",
              attrs: {
                model: _vm.kapayerBaseEditForm,
                rules: _vm.kapayerBaseEditRules,
                "label-width": "150px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "快安App Key：", prop: "appKey" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.kapayerBaseEditForm.appKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.kapayerBaseEditForm, "appKey", $$v)
                      },
                      expression: "kapayerBaseEditForm.appKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "快安App Secret：", prop: "appSecret" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.kapayerBaseEditForm.appSecret,
                      callback: function ($$v) {
                        _vm.$set(_vm.kapayerBaseEditForm, "appSecret", $$v)
                      },
                      expression: "kapayerBaseEditForm.appSecret",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "快安岗位 ID：", prop: "jobId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.kapayerBaseEditForm.jobId,
                      callback: function ($$v) {
                        _vm.$set(_vm.kapayerBaseEditForm, "jobId", $$v)
                      },
                      expression: "kapayerBaseEditForm.jobId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onKapayerBaseEditConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { on: { click: _vm.onKapayerBaseEditReset } },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "10px",
          color: "#F59A23",
          "background-color": "#FFFFFF",
          padding: "15px",
          "border-radius": "10px",
        },
      },
      [
        _c("div", [
          _vm._v(
            "\n     1.什么是“转账账号”：指平台向用户进行打款转账操作时使用的支付账号；\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "5px" } }, [
          _vm._v(
            "\n      2.使用场景：在用户进行“提现”或平台向用户账户充值时会使用该账号进行转账，如未配置，将无法完成打款；\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "5px" } }, [
          _vm._v("请注意！当转账账户余额不足时，会导致打款失败！"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }